module.exports = __webpack_public_path__ + "static/img/ezwel-renewal.905ec25.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/ezwel-renewal.jpg
// module id = QtPp
// module chunks = 0